export default __webpack_public_path__ + "static/iconfont-f1216f06b69adba5c7fff128a638616e.woff";